jQuery(function($) {

  const checklistGrids = $('[data-checklist-grid]')

  function checklistGrid(selector) {
    const checklistGrid = $(selector)
    const viewMoreToggle = checklistGrid.find('[data-view-more]')
    const expandableGridItems = checklistGrid.find('[data-expandable-grid-items]')

    $(window).load(function() {
      const expandableGridItemsHeight = expandableGridItems.outerHeight()
      //set data height attribute to height
      expandableGridItems.attr('data-height', expandableGridItemsHeight)
      expandableGridItems.addClass('hidden')
    })

    viewMoreToggle.on('click', function() {
      if(expandableGridItems.height() == expandableGridItems.attr('data-height')) {
        expandableGridItems.height(0)
      } else {
        expandableGridItems.height(expandableGridItems.attr('data-height'))
      }

      expandableGridItems.toggleClass('hidden')
      viewMoreToggle.toggleClass('active')

      if(viewMoreToggle.hasClass('active')) {
        viewMoreToggle.find('.view_more_text').text('View Less')
      } else {
        viewMoreToggle.find('.view_more_text').text('View More')
      }
    })
  }

  if(checklistGrids.length) {
    //for each checlistGrids item pass selector into checklistGrid function
    checklistGrids.each(function() {
      new checklistGrid('#' + $(this).attr('id'))
    })
  }
});
